/* src/app/shared/shop/add-cart-popup/add-cart-popup.component.scss */
h1 {
  font-size: 42px !important;
  font-weight: 600;
}
.modal-container {
  color: black;
  height: 100%;
}
.product-container {
  padding: 20px;
  height: 100%;
  width: 100%;
}
app-notebook-preview {
  background-color: #f4f4f4;
  border-radius: 10px;
  padding: 1.4em;
  width: 100%;
}
app-product-part-info-interaction {
  display: contents;
}
.product-part-info-interaction-style {
  background-color: #f6f6f6;
  border-radius: 15px;
  height: 504px;
}
.img-product {
  width: 100%;
  max-height: 100%;
}
@media only screen and (max-device-width: 500px) and (orientation: portrait) {
  .img-product {
    max-width: 200px !important;
  }
}
.close {
  position: absolute;
  top: 5px;
  right: 5px;
  height: auto;
  z-index: 99;
}
.close::part(native) {
  padding: 0;
}
.close ion-icon {
  color: black;
  font-size: 30px;
}
.column {
  height: 100%;
}
/*# sourceMappingURL=add-cart-popup.component-62HY6X3M.css.map */
